export const initialValues = {
  application: {
    name: '',
    streetAddress: '',
    city: 'Birmingham',
    state: 'Alabama',
    zipCode: '',
    phone: '',
    neighborhood: '',
    dob: '',
    gender: '',
    maritalStatus: '',
    disabled: '',
    hasAssets: '',
    receivedAssistance: '',
    race: [],
    doChildrenLive: '',
    requestedInsurance: '',
    wasBuiltBefore1978: '',
    femaleHeadOfHousehold: '',
  },
  householdIncome: [],
  scope: {
    roofing: null,
    plumbing: null,
    electrical: null,
    heatAndAir: null,
    structural: null,
    painting: null,
  },
};
